function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00011,0,0,1,3,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.998,10L10,10L10,18L7.998,18L7.998,10L0,10L0,8L7.998,8L7.998,0L10,0L10,8L17.998,8L17.998,10Z",
    style: {
      fill: "rgb(49,102,199)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPrimary);
export default __webpack_public_path__ + "static/media/add-primary.9b92264f194e628ae492ba5ca9093b04.svg";
export { ForwardRef as ReactComponent };